module.exports = __webpack_public_path__ + "img/2.e761642c.png";